// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"470":"828896b4","897":"00665ed9"}[chunkId] + ".chunk.css");